export enum TimezoneRegionsEnum {
	Africa = "Africa",
	America = "America",
	Antarctica = "Antarctica",
	Asia = "Asia",
	Atlantic = "Atlantic",
	Australia = "Australia",
	Europe = "Europe",
	Indian = "Indian",
	Pacific = "Pacific",
	Brazil = "Brazil",
	Canada = "Canada",
}
